import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import StylePropType from 'react-style-proptype';
import Spinner from 'react-spinkit';

import ProjectListFooter from './ProjectListFooter';
import Styles from './ProjectList.styles';
import ProjectListHeader from './ProjectListHeader/ProjectListHeader';
import ProjectListTable from './ProjectListTable/ProjectListTable';
import ProjectListGrid from './ProjectListGrid/ProjectListGrid';
import LISTVIEW_TYPES from './listViewTypes';
import ProjectRemoveButton from '../ProjectRemoveButton';
import ProjectEditButton from '../ProjectEditButton';
import ProjectListFooterLink from './ProjectListFooterLink';

class ProjectList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      batchEdit: false,
      listViewType: localStorage.getItem('selectedListView') || LISTVIEW_TYPES.list,
      selected: [],
    };
    this.changeListView = this.changeListView.bind(this);
    this.toggleBatchEdit = this.toggleBatchEdit.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({ projects: newProps.projects });
  }

  onRowClick(index) {
    const project = this.props.projects.find(prj => prj.key === index);
    if (project) {
      this.props.selectProject(project.key);
    }
  }

  onSubmit(event) {
    event.preventDefault();
    const {
      selected,
      firebase: { update },
    } = this.props;
    const updates = {};
    selected.forEach((key) => {
      updates[key] = null;
    });
    update('/projects', updates);
    this.props.deselectAll();
  }

  changeListView(type) {
    localStorage.setItem('selectedListView', type);
    this.setState({
      listViewType: type,
    });
  }

  toggleBatchEdit() {
    this.props.toggleBatchEdit();
  }

  renderFooter() {
    const { selected } = this.props;
    const selectedId = selected.length === 1 ? selected[0] : null;
    return (
      <ProjectListFooter>
        {selectedId && (
          <ProjectListFooterLink
            label="Editor"
            url={`/editor/${selectedId}`}
            style={{ background: 'rgb(76,77,74)' }}
          />
        )}
        {selectedId && (
          <ProjectListFooterLink label="Map Editor" url={`/map-editor/${selectedId}`} />
        )}
        <ProjectEditButton onClick={this.props.onEdit} selected={selected} />
        <ProjectRemoveButton onSubmit={this.onSubmit} selected={selected} />
      </ProjectListFooter>
    );
  }

  render() {
    const { listViewType } = this.state;
    const { selected, batchEdit, style, isRequesting } = this.props;
    let { projects } = this.props;
    if (projects === null) {
      projects = [];
    }

    if (isRequesting || !projects.length) {
      return (
        <div style={[Styles.container, style, Styles.spinnerContainer]}>
          <Spinner name="ball-triangle-path" fadeIn="none" />
        </div>
      );
    }

    return (
      <div style={[Styles.container, style]}>
        <ProjectListHeader
          listViewType={listViewType}
          changeListView={this.changeListView}
          toggleBatchEdit={this.toggleBatchEdit}
        />
        {listViewType === LISTVIEW_TYPES.grid ? (
          <ProjectListGrid
            listViewType={listViewType}
            batchEdit={batchEdit}
            onElementClick={this.onRowClick}
            projects={projects}
            selected={selected}
          />
        ) : (
          <ProjectListTable
            listViewType={listViewType}
            batchEdit={batchEdit}
            onRowClick={this.onRowClick}
            projects={projects}
            selected={selected}
          />
        )}
        {selected.length > 0 && this.renderFooter()}
      </div>
    );
  }
}

ProjectList.propTypes = {
  projects: PropTypes.arrayOf(Object).isRequired,
  style: StylePropType.isRequired,
  selectProject: PropTypes.func.isRequired,
  deselectAll: PropTypes.func.isRequired,
  toggleBatchEdit: PropTypes.func.isRequired,
  batchEdit: PropTypes.bool.isRequired,
  selected: PropTypes.arrayOf(Object).isRequired,
  isRequesting: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  firebase: PropTypes.shape({
    remove: PropTypes.func.isRequired,
  }).isRequired,
};

export default Radium(ProjectList);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectList.js